import React from 'react';
import FalconCardHeader from 'components/common/FalconCardHeader';
import PropTypes from 'prop-types';
import IconButton from 'components/common/IconButton';

const MyVisitHisHeader = ({ toggelFilter }) => {
  // const [keyword, setKeyword] = useState('');

  return (
    <div>
      <FalconCardHeader
        title="Visits"
        light
        titleTag="h6"
        endEl={
          <div
            id="orders-actions"
            className="d-flex align-items-center justify-content-between"
          >
            <div id="orders-actions">
              <IconButton
                variant="falcon-default"
                size="md"
                icon="filter"
                transform="shrink-3"
                className="mx-2"
                onClick={toggelFilter}
              >
                <span className="d-none d-sm-inline-block ms-1">Filter</span>
              </IconButton>
            </div>
          </div>
        }
      />
    </div>
  );
};

MyVisitHisHeader.propTypes = {
  toggelFilter: PropTypes.func,
  handleSearch: PropTypes.func,
  toggelModal: PropTypes.func
};

export default MyVisitHisHeader;
